export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4" data-testid={testid || "page-header"}>
      <div className="max-w-2xl">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 dark:text-slate-100 tracking-tight">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-sm md:text-base text-slate-500 dark:text-slate-400 leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
